/* Rquiere de mixin.js */

var lotChurchChurch = {
	data () {
		return {
			dateFromLotChurchs: '2020-07-15',
			dateToLotChurchs: '2020-07-18',
			listLotChurchs: [],
			methodsLotChurch: {
				delete: '/delete',
				get: '/churchs',
				show: 'lotChurch/',
			},
            objectLotChurch: {
                exists: 0,
                id: 0,
                lot_id: 0,
                lot: {},
                church_id: 0,
                church: {},
                order_id: 0,
                order: {},
                created_at: '',
                updated_at: ''
            },
            paginationLotChurchs: [],
            qRowsLotChurch: 25,
            searchLotChurchs: ''
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
        changeQRowsLotChurch() {
            localStorage.setItem('qRowsLotChurch', this.qRowsLotChurch)
			this.changeQRowsLotChurchLocal()
        },
		changeQRowsLotChurchLocal() {
			console.log('changeQRowsLotChurchLocal no desarrollado')
		},
        clearObjectLotChurch() {
            this.objectLotChurch.exists = 0
            this.objectLotChurch.id = 0
            this.objectLotChurch.lot_id = 0
            this.objectLotChurch.lot = {}
            this.objectLotChurch.church_id = 0
            this.objectLotChurch.church = {}
            this.objectLotChurch.order_id = 0
            this.objectLotChurch.order = {}
            this.objectLotChurch.created_at = ''
            this.objectLotChurch.updated_at = ''
        },
        getAllLotChurchs(idLot) {
            this.listLotChurchs = []
            let url = this.apiBackend + 'lot/' + idLot + this.methodsLotChurch.get
            this.$emit('showLockScreen', 'Obteniendo lista de LotChurches . . .')
			this.axiosActionIS(url, 'GET', 'getAllLotChurchsResult')
        },
        getAllLotChurchsResult(response) {
            if(response.data.success === true) {
                this.listLotChurchs = response.data.data
            }
            this.getAllLotChurchsResultLocal(response)
        },
        getAllLotChurchsResultLocal(response) {
            console.log('getAllLotChurchsResultLocal no desarrollado', response)
        },
        goBackSendSubscription(id) {
            let url = this.apiBackend + 'lot/' + id + '/goBack'
            this.axiosActionIS(url, 'DELETE', 'goBackSendSubscriptionResult')
            console.log(url)
        },
        goBackSendSubscriptionResult(response) {
            this.goBackSendSubscriptionResultLocal(response)
        },
        goBackSendSubscriptionResultLocal(response) {
            console.log('goBackSendSubscriptionResultLocal no desarrollado', response)
        },
		setLotChurchInit() {
			this.qRowsLotChurch = (localStorage.getItem('qRowsLotChurch') === null) ? this.qRowsLotChurch : localStorage.getItem('qRowsLotChurch')
			this.dateFromLotChurchs = this.currentDate(-30)
			this.dateToLotChurchs = this.currentDate()
			this.setLotChurchInitLocal()
		},
        setLotChurchInitLocal() {
            console.log('setLotChurchInitLocal no desarrollado')
        }
	},
};

export default lotChurchChurch;